export default __webpack_public_path__ + "static/media/play-video-icon.fca2215d.svg";